import React, { useRef, useState } from 'react';
import Image from '../images';
import './GPXUpload.scss';

const GPXUpload = ({ onFileUpload, onSnapToRoads, isLoading, isSnapping, hasGPXData, isSnapped }) => {
  const fileInputRef = useRef(null);
  const [fileName, setFileName] = useState('');
  const [error, setError] = useState('');

  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (!file.name.toLowerCase().endsWith('.gpx')) {
      setError('Please upload a valid GPX file');
      return;
    }

    setFileName(file.name);
    setError('');
    onFileUpload(file);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    if (!file) return;

    if (!file.name.toLowerCase().endsWith('.gpx')) {
      setError('Please upload a valid GPX file');
      return;
    }

    setFileName(file.name);
    setError('');
    onFileUpload(file);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleSampleFileClick = () => {
    window.open('/sample.gpx', '_blank');
  };

  return (
    <div className="gpx-upload">
      <div className="upload-header">
        <h3>Upload GPX File</h3>
        <p>Upload a GPX file to visualize the track points and snapped-to-roads path on the map</p>
      </div>

      <div
        className="upload-area"
        onDrop={handleDrop}
        onDragOver={handleDragOver}
        onClick={() => fileInputRef.current?.click()}
      >
        <input ref={fileInputRef} type="file" accept=".gpx" onChange={handleFileSelect} style={{ display: 'none' }} />

        {isLoading ? (
          <div className="upload-content loading">
            <div className="spinner"></div>
            <p>Processing GPX file...</p>
          </div>
        ) : fileName ? (
          <div className="upload-content success">
            <Image type="CheckIcon" color="#4CAF50" />
            <p className="file-name">{fileName}</p>
            <button
              className="change-file-btn"
              onClick={(e) => {
                e.stopPropagation();
                fileInputRef.current?.click();
              }}
            >
              Change File
            </button>
          </div>
        ) : (
          <div className="upload-content">
            <Image type="UploadIcon" color="#2196F3" />
            <p className="upload-text">Click to upload or drag and drop</p>
            <p className="upload-hint">GPX file only</p>
          </div>
        )}
      </div>

      {error && <div className="error-message">{error}</div>}

      {/* Snap to Roads button - show when GPX data is loaded */}
      {hasGPXData && (
        <div className="snap-to-roads-section">
          <button
            className={`snap-to-roads-btn ${isSnapped ? 'snapped' : ''}`}
            onClick={onSnapToRoads}
            disabled={isSnapping || isSnapped}
          >
            {isSnapping ? (
              <>
                <div className="spinner small"></div>
                <span>Snapping to Roads...</span>
              </>
            ) : isSnapped ? (
              <>
                <Image type="CheckIcon" color="#fff" />
                <span>Snapped to Roads</span>
              </>
            ) : (
              <span>Snap to Roads</span>
            )}
          </button>
        </div>
      )}

      <div className="sample-file-section">
        <p>Need a sample file?</p>
        <button className="sample-file-btn" onClick={handleSampleFileClick}>
          Download Sample GPX
        </button>
      </div>
    </div>
  );
};

export default GPXUpload;
